import { resolveTaskPriorityParams } from 'components/root/Container/Layout/Tasks/Task/taskServices';

import './TaskDetailsPriority.scss';
export default function TaskDetailsPriority({ taskForm }) {
  const priorityParams = resolveTaskPriorityParams(taskForm?.priority);

  if (!priorityParams) return null;

  const { backgroundColor, TaskIcon, color, label } = priorityParams;
  return (
    <div className="etc-body-details">
      <div className="etc-body-details-block">
        <div className="etc-priority-block" style={{ backgroundColor: backgroundColor }}>
          <TaskIcon sx={{ color: color }} />
          <span className="etc-priority-label" style={{ color: color }}>
            {label}
          </span>
        </div>
      </div>
    </div>
  );
}
